module.exports = __webpack_public_path__ + "img/about_cover.14f9650f.png";